var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "countries-menu-container",
      staticStyle: { position: "relative", height: "100%", padding: "10px" },
    },
    [
      _c(
        "el-tabs",
        {
          attrs: { type: "border-card" },
          model: {
            value: _vm.activeName,
            callback: function ($$v) {
              _vm.activeName = $$v
            },
            expression: "activeName",
          },
        },
        [
          _c(
            "el-tab-pane",
            { attrs: { label: "國家與經緯度", name: "tab1" } },
            [
              _c(
                "div",
                {
                  staticStyle: {
                    position: "relative",
                    height: "100%",
                    padding: "10px",
                  },
                },
                [
                  _c("countries-ponsition", {
                    attrs: {
                      refreshTab1: _vm.refreshObj.refreshTab1,
                      callback: _vm.reload,
                    },
                  }),
                ],
                1
              ),
            ]
          ),
          _c("el-tab-pane", { attrs: { label: "國家城市", name: "tab2" } }, [
            _c(
              "div",
              {
                staticStyle: {
                  position: "relative",
                  height: "100%",
                  padding: "10px",
                },
              },
              [_c("countries-setting", { attrs: { callback: _vm.reload } })],
              1
            ),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }